<template>
  <main v-if="eventDetailsData" class="event-details-page px-md-10 px-4 pt-16">
    <ErrorAlert :error-message="errorMessage" v-if="isError">
      {{ eventsData.confirmationErrorTitle }}<br class="d-block d-md-none" />
      {{ eventsData.confirmationErrorDescription }}
    </ErrorAlert>
    <div v-else>
      <section class="my-6">
        <h1 class="headingTitle">
          {{ eventsData.confirmationQuizText }}
        </h1>
      </section>

      <v-row>
        <v-col cols="12" class="col-md-4">
          <section>
            <div class="infoCard py-7 px-8">
              <h3>{{ eventDetailsData.topic }}</h3>
              <v-divider class="my-4" />

              <div class="infoDescriptionWrapper">
                <p
                  v-if="eventDetailsData.info"
                  class="infoDescription"
                  v-html="eventDetailsData.info"
                />
                <p
                  v-if="eventsData.teamInfo"
                  class="infoDescription"
                  v-html="eventsData.teamInfo"
                />
              </div>
            </div>
          </section>
        </v-col>
      </v-row>
    </div>
  </main>
</template>

<script>
import ErrorAlert from "@/components/alert/ErrorAlert.vue";

export default {
  name: "EventDetailsConfirmationPage",
  components: { ErrorAlert },
  computed: {
    eventsData() {
      return this.$t("events");
    },

    eventDetailsData() {
      const slug = this.$route.params.slug;
      const eventDetailsData = this.$t("events");

      if (slug && eventDetailsData.eventList) {
        return eventDetailsData.eventList.find(
          eventItem => eventItem.slug === slug
        );
      }

      return null;
    }
  },
  data() {
    return {
      isError: false,
      errorMessage: ""
    };
  },
  mounted() {
    if (this.$route.query?.status === "error") {
      this.isError = true;
      this.errorMessage = this.$route.query?.message || "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";
@import "src/assets/style/media";

.event-details-page {
  padding-bottom: 56px;
}

.headingTitle {
  font-family: "Roboto", sans-serif;
  font-size: 36px;
  line-height: 1.15;
  font-weight: 700;
  max-width: 60%;

  @include mobileMedia {
    max-width: 100%;
  }
}

.infoCard {
  display: flex;
  flex-direction: column;
  background: $bgLight;
  min-height: 400px;
}

.infoDescriptionWrapper {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  margin-top: 12px;
}

.infoDescription {
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  margin: 0;
  color: $grey;
}
</style>
